// components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children, allowedRoles = [] }) => {
  const token = localStorage.getItem("eseva_token");
  const adminData = JSON.parse(localStorage.getItem("eseva_admin") || "{}");
  const role = adminData?.role;

  if (!token) return <Navigate to="/admin/login" />;
  if (allowedRoles.length && !allowedRoles.includes(role))
    return <Navigate to="/admin" />; // redirect normal admin away

  return children;
};

export default ProtectedAdminRoute;
